import type { InspectionTemplate } from 'inspection-types';

import { countTemplate } from '../model/counts';
import { formatUpdatedAt } from '../model/formatUpdatedAt';
import { LABEL_KEYS, type Message } from './messages';

export type TemplateHeaderViewModel = {
  name: string;
  lastUpdated: Message;
  summary: Message;
};

const MISSING_DATE = '–';

export function createTemplateHeaderViewModel(
  template: InspectionTemplate
): TemplateHeaderViewModel {
  const { sections, questions } = countTemplate(template);

  return {
    name: template.metadata.name,
    lastUpdated: {
      key: LABEL_KEYS.lastUpdated,
      params: {
        date: formatUpdatedAt(template.metadata.updatedAt) ?? MISSING_DATE,
      },
    },
    summary: {
      key: LABEL_KEYS.templateSummary,
      params: { sections, questions },
    },
  };
}
